/* CarbonMarket: wishlist (local, no backend yet) + footer language switch.
   Progressive enhancement: every page renders fully without this file. */
(() => {
  const KEY = 'cm:wishlist';
  let saved;
  try {
    saved = new Set(JSON.parse(localStorage.getItem(KEY) || '[]'));
  } catch {
    saved = new Set();
  }
  const persist = () => {
    try {
      localStorage.setItem(KEY, JSON.stringify([...saved]));
    } catch {}
  };

  const page = document.querySelector('[data-cm-wishlist]');
  let i18n = {};
  try {
    i18n = JSON.parse(document.getElementById('cm-i18n').textContent) || {};
  } catch {}
  const labelOn = (page && page.dataset.labelOn) || i18n.wishlist_remove || 'Remove from favorites';
  const labelOff = (page && page.dataset.labelOff) || i18n.wishlist_add || 'Add to favorites';

  const sync = (btn) => {
    const on = saved.has(btn.dataset.cmWish);
    btn.setAttribute('aria-pressed', String(on));
    btn.classList.toggle('is-saved', on);
    btn.setAttribute('aria-label', on ? labelOn : labelOff);
  };
  const badges = document.querySelectorAll('[data-cm-wish-count]');
  const paintBadges = () => {
    badges.forEach((b) => {
      b.textContent = String(saved.size);
      b.hidden = saved.size === 0;
    });
  };

  document.querySelectorAll('[data-cm-wish]').forEach(sync);
  paintBadges();

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cm-wish]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.cmWish;
    if (saved.has(handle)) saved.delete(handle);
    else saved.add(handle);
    persist();
    sync(btn);
    paintBadges();
    // Only the save direction pops (see cm-pop in carbonmarket.css).
    btn.classList.remove('is-pop');
    if (saved.has(handle)) {
      void btn.offsetWidth;
      btn.classList.add('is-pop');
    } else if (page) {
      const card = btn.closest('.cm-card');
      if (card) card.remove();
      updateWishlistState();
    }
  });

  /* ---------- Wishlist page ---------- */
  const esc = (s) =>
    String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  // Prices are stored net when the theme's "cm_prices_net" setting is on: add
  // the visitor's VAT the way checkout does (tax = round(net × rate)).
  const vat = (() => { try { return JSON.parse(document.getElementById('cm-vat')?.textContent || '{}'); } catch (e) { return {}; } })();
  const gross = (cents, p) => {
    if (!vat.net) return cents;
    let rate = Number(vat.rate) || 0;
    if (vat.country === 'HU' && p && Array.isArray(p.tags) && p.tags.includes(vat.huReducedTag)) rate = Number(vat.huReduced) || rate;
    return cents + Math.round((cents * rate) / 100);
  };
  // Mirrors Shopify's money filter for the store's money_format tokens.
  const money = (cents, format) => {
    const n = cents / 100;
    const group = (int, sep) => int.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const fmt = (dec, thousands, decimal) => {
      const [i, d] = n.toFixed(dec).split('.');
      return group(i, thousands) + (d ? decimal + d : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, token) => {
      switch (token) {
        case 'amount_no_decimals':
          return fmt(0, ',', '');
        case 'amount_with_comma_separator':
          return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return fmt(0, '.', '');
        case 'amount_with_space_separator':
          return fmt(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return fmt(0, ' ', '');
        case 'amount_with_apostrophe_separator':
          return fmt(2, "'", '.');
        default:
          return fmt(2, ',', '.');
      }
    });
  };

  const cardHtml = (p, shopName, format, compact) => {
    const dim = compact ? 360 : 720;
    const img = p.featured_image
      ? p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=' + dim
      : '';
    const norm = (v) => String(v || '').toLowerCase().replace(/[\s-]/g, '');
    const vendor = `<p class="cm-card__vendor">${!compact && p.vendor && norm(p.vendor) !== norm(shopName) ? esc(p.vendor) : ''}</p>`;
    const on = saved.has(p.handle);
    const variant = p.variants && p.variants[0];
    const available = !!(variant && variant.available);
    const form = variant
      ? `<product-form class="cm-card__form" data-hide-errors="true">
    <form method="post" action="/cart/add" class="cm-card__form-el" novalidate data-type="add-to-cart-form">
      <input type="hidden" name="id" value="${variant.id}"${available ? '' : ' disabled'} class="product-variant-id">
      <button type="submit" class="cm-card__add"${available ? '' : ' disabled aria-disabled="true"'}><span>${available ? i18n.add_to_cart || 'Add to cart' : i18n.sold_out || 'Sold out'}</span><span class="loading__spinner hidden"></span></button>
    </form>
  </product-form>`
      : '';
    const compare =
      p.compare_at_price && p.compare_at_price > p.price ? `<s>${esc(money(gross(p.compare_at_price, p), format))}</s>` : '';
    return `<article class="cm-card${compact ? ' cm-card--compact' : ''}">
  <a href="/products/${esc(p.handle)}" class="cm-card__link">
    <div class="cm-card__tile">${img ? `<img src="${esc(img)}" alt="${esc(p.title)}" width="${dim}" height="${dim}" loading="lazy" class="cm-card__img">` : ''}</div>
    <div class="cm-card__body">${vendor}<h3 class="cm-card__title">${esc(p.title)}</h3>
      <p class="cm-card__price">${esc(money(gross(p.price, p), format))}${compare}</p>
    </div>
  </a>
  <button type="button" class="cm-heart${on ? ' is-saved' : ''}" data-cm-wish="${esc(p.handle)}" aria-pressed="${on}" aria-label="${esc(on ? labelOn : labelOff)}">
    <span class="cm-heart__ico cm-heart__ico--off">${heartOff}</span>
    <span class="cm-heart__ico cm-heart__ico--on">${heartOn}</span>
  </button>
  ${form}
</article>`;
  };
  const heartOff =
    '<svg class="cm-icon" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="M178,40c-20.65,0-38.73,8.88-50,23.89C116.73,48.88,98.65,40,78,40a62.07,62.07,0,0,0-62,62c0,70,103.79,126.66,108.21,129a8,8,0,0,0,7.58,0C136.21,228.66,240,172,240,102A62.07,62.07,0,0,0,178,40ZM128,214.8C109.74,204.16,32,155.69,32,102A46.06,46.06,0,0,1,78,56c19.45,0,35.78,10.36,42.6,27a8,8,0,0,0,14.8,0c6.82-16.67,23.15-27,42.6-27a46.06,46.06,0,0,1,46,46C224,155.61,146.24,204.15,128,214.8Z"/></svg>';
  const heartOn =
    '<svg class="cm-icon" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="M240,102c0,70-103.79,126.66-108.21,129a8,8,0,0,1-7.58,0C119.79,228.66,16,172,16,102A62.07,62.07,0,0,1,78,40c20.65,0,38.73,8.88,50,23.89C139.27,48.88,157.35,40,178,40A62.07,62.07,0,0,1,240,102Z"/></svg>';

  function updateWishlistState() {
    if (!page) return;
    const grid = page.querySelector('[data-cm-wishlist-grid]');
    const empty = page.querySelector('[data-cm-wishlist-empty]');
    const count = page.querySelector('[data-cm-wishlist-count]');
    const n = grid.children.length;
    empty.hidden = n > 0;
    count.hidden = n === 0;
    count.textContent = n + ' termék';
  }

  async function renderWishlist() {
    const grid = page.querySelector('[data-cm-wishlist-grid]');
    const handles = [...saved];
    const products = (
      await Promise.all(
        handles.map((h) =>
          fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
      )
    ).filter(Boolean);
    // Drop handles that no longer resolve to a product.
    handles.forEach((h) => {
      if (!products.some((p) => p.handle === h)) saved.delete(h);
    });
    persist();
    paintBadges();
    grid.innerHTML = products.map((p) => cardHtml(p, page.dataset.shopName, page.dataset.moneyFormat)).join('');
    grid.querySelectorAll('[data-cm-wish]').forEach(sync);
    updateWishlistState();
  }
  if (page) renderWishlist();

  /* ---------- "Kedvenceid alapján": recommendations from the wishlist ---------- */
  const forYou = document.querySelector('[data-cm-foryou]');
  async function renderForYou() {
    const seeds = [...saved].slice(-6).reverse();
    if (!seeds.length) return;
    const limit = parseInt(forYou.dataset.limit, 10) || 12;
    const getJson = (url) =>
      fetch(url, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);
    const seedProducts = (
      await Promise.all(seeds.map((h) => getJson('/products/' + encodeURIComponent(h) + '.js')))
    ).filter(Boolean);
    if (!seedProducts.length) return;
    const base = forYou.dataset.url;
    const calls = [];
    seedProducts.forEach((p) => {
      calls.push(getJson(`${base}?product_id=${p.id}&limit=6&intent=related`));
      calls.push(getJson(`${base}?product_id=${p.id}&limit=4&intent=complementary`));
    });
    const results = await Promise.all(calls);
    const seen = new Set(saved);
    const picks = [];
    // Interleave the lists so every favourite contributes before any one dominates.
    const lists = results.map((r) => (r && r.products ? r.products.slice() : []));
    while (picks.length < limit && lists.some((l) => l.length)) {
      for (const l of lists) {
        const p = l.shift();
        if (!p || seen.has(p.handle)) continue;
        seen.add(p.handle);
        picks.push(p);
        if (picks.length >= limit) break;
      }
    }
    if (!picks.length) return;
    const rail = forYou.querySelector('[data-cm-foryou-rail]');
    rail.innerHTML = picks
      .map((p) => `<li>${cardHtml(p, forYou.dataset.shopName, forYou.dataset.moneyFormat, true)}</li>`)
      .join('');
    rail.querySelectorAll('[data-cm-wish]').forEach(sync);
    forYou.hidden = false;
  }
  if (forYou) renderForYou();

  /* ---------- Cart count: mirror Dawn's bubble into our badges ---------- */
  const cartLink = document.getElementById('cart-icon-bubble');
  if (cartLink) {
    const ownIcon = cartLink.querySelector('svg.cm-icon') ? cartLink.querySelector('svg.cm-icon').outerHTML : '';
    const paintCart = (n) => {
      document.querySelectorAll('[data-cm-cart-count]').forEach((b) => {
        b.textContent = String(n);
        b.hidden = n === 0;
      });
    };
    const restore = () => {
      // Dawn replaces the link's content with its own icon after cart changes;
      // read the count from it and put our markup back.
      if (cartLink.querySelector('svg.cm-icon')) return;
      const bubble = cartLink.querySelector('.cart-count-bubble span[aria-hidden]');
      const n = bubble ? parseInt(bubble.textContent, 10) || 0 : 0;
      cartLink.innerHTML = ownIcon + (n > 0 ? `<span class="cm-badge" data-cm-cart-count aria-hidden="true">${n}</span>` : '');
      paintCart(n);
    };
    new MutationObserver(restore).observe(cartLink, { childList: true });
  }

  /* ---------- Cards: show which products are already in the cart ---------- */
  const cartLines = new Map();
  const paintInCart = () => {
    document.querySelectorAll('.cm-card__form form').forEach((form) => {
      const card = form.closest('.cm-card');
      const input = form.querySelector('.product-variant-id');
      const button = form.querySelector('.cm-card__add');
      if (!card || !input || !button || button.disabled) return;
      const qty = cartLines.get(String(input.value)) || 0;
      const label = button.querySelector('span[data-cm-label]') || button.querySelector('span:not(.loading__spinner)');
      if (!label) return;
      if (!label.dataset.cmLabel) label.dataset.cmLabel = label.textContent.trim();
      card.classList.toggle('is-in-cart', qty > 0);
      const text = qty > 0 ? i18n.add_more_to_cart || 'Add more to cart' : label.dataset.cmLabel;
      if (label.textContent !== text) label.textContent = text;
      let pill = card.querySelector('.cm-card__incart');
      if (qty > 0) {
        if (!pill) {
          pill = document.createElement('span');
          pill.className = 'cm-card__incart';
          card.appendChild(pill);
        }
        const pillText = qty + ' ' + (i18n.in_cart || 'in cart');
        if (pill.textContent !== pillText) pill.textContent = pillText;
      } else if (pill) {
        pill.remove();
      }
    });
  };
  const readCart = () => {
    const url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => {
        if (!cart) return;
        cartLines.clear();
        (cart.items || []).forEach((item) => {
          cartLines.set(String(item.variant_id), (cartLines.get(String(item.variant_id)) || 0) + item.quantity);
        });
        paintInCart();
      })
      .catch(() => {});
  };
  if (document.querySelector('.cm-card__form')) {
    readCart();
    let cartTimer;
    const queueCartRead = () => {
      clearTimeout(cartTimer);
      cartTimer = setTimeout(readCart, 250);
    };
    document.addEventListener('submit', (e) => {
      if (e.target.closest('.cm-card__form, product-form')) setTimeout(queueCartRead, 600);
    }, true);
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble) new MutationObserver(queueCartRead).observe(bubble, { childList: true, subtree: true, characterData: true });
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(queueCartRead).observe(drawer, { childList: true, subtree: true });
    let paintTimer;
    const grid = document.getElementById('ProductGridContainer') || document.querySelector('.cm-grid, .cm-rail');
    if (grid) {
      new MutationObserver(() => {
        clearTimeout(paintTimer);
        paintTimer = setTimeout(paintInCart, 60);
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  /* ---------- Cookie consent via Shopify's Customer Privacy API ---------- */
  const consent = document.querySelector('[data-cm-consent]');
  if (consent && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) return;
      const api = window.Shopify.customerPrivacy;
      if (!api || typeof api.shouldShowBanner !== 'function' || !api.shouldShowBanner()) return;
      // shouldShowBanner() only says the region needs a banner; it stays true
      // after a choice. Show the card only while the visitor is undecided, and
      // keep our own record so a decision is never asked for twice.
      let saved = null;
      try {
        saved = localStorage.getItem('cm:consent');
      } catch {}
      const current = typeof api.currentVisitorConsent === 'function' ? api.currentVisitorConsent() : null;
      const undecided = !current || Object.values(current).some((v) => v === '');
      if (saved && undecided) {
        const g = saved === 'granted';
        api.setTrackingConsent({ analytics: g, marketing: g, preferences: g, sale_of_data: g }, () => {});
        return;
      }
      if (saved || !undecided) return;
      // If the API call failed earlier in this session (e.g. behind the local
      // theme-dev proxy), do not nag on every page.
      let dismissed = false;
      try {
        dismissed = sessionStorage.getItem('cm:consent-dismissed') === '1';
      } catch {}
      if (dismissed) return;
      consent.hidden = false;
      const decide = (granted) => {
        try {
          localStorage.setItem('cm:consent', granted ? 'granted' : 'denied');
        } catch {}
        consent.hidden = true;
        api.setTrackingConsent(
          { analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted },
          (result) => {
            consent.hidden = true;
            if (result && result.error) {
              try {
                sessionStorage.setItem('cm:consent-dismissed', '1');
              } catch {}
            }
          }
        );
      };
      consent.querySelector('[data-cm-consent-accept]').addEventListener('click', () => decide(true));
      consent.querySelector('[data-cm-consent-decline]').addEventListener('click', () => decide(false));
    });
  }

  /* ---------- Cart page: reserve space for the floating summary bar ---------- */
  const cartBar = document.getElementById("main-cart-footer");
  if (cartBar && "ResizeObserver" in window) {
    const setBarHeight = () => {
      document.documentElement.style.setProperty("--cm-cartbar-h", cartBar.offsetHeight + "px");
    };
    new ResizeObserver(setBarHeight).observe(cartBar);
    setBarHeight();
  }

  /* ---------- "Süti beállítások" links reopen the consent card ---------- */
  document.querySelectorAll('a[href$="#cm-consent"]').forEach((link) => {
    link.addEventListener("click", (e) => {
      const card = document.querySelector("[data-cm-consent]");
      if (!card) return;
      e.preventDefault();
      card.hidden = false;
      const first = card.querySelector("button");
      if (first) first.focus();
    });
  });

  /* ---------- Footer language menu ----------
     A details/summary popover. Links point at each language root; with
     JavaScript the current path is kept (a GET, which also works through the
     local theme-dev proxy where the localization form POST is refused).
     Closes on outside click and Escape. */
  document.querySelectorAll("[data-cm-lang]").forEach((menu) => {
    const cur = (menu.dataset.currentRoot || "/").replace(/\/$/, "");
    menu.querySelectorAll("[data-url]").forEach((link) => {
      const base = (link.dataset.url || "/").replace(/\/$/, "");
      let path = window.location.pathname;
      if (cur && path.indexOf(cur) === 0) path = path.slice(cur.length) || "/";
      link.href = base + path + window.location.search;
    });
    document.addEventListener("click", (e) => {
      if (menu.open && !menu.contains(e.target)) menu.open = false;
    });
    menu.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && menu.open) {
        menu.open = false;
        menu.querySelector("summary").focus();
      }
    });
  });

  /* ---------- Category bar: hide on scroll down, show on scroll up ---------- */
  /* Mobile: the header's search button opens the field in a second row. */
  const header = document.querySelector('.cm-header');
  const searchToggle = header && header.querySelector('.cm-iconbtn--search');
  const headerSearch = header && header.querySelector('.cm-header__search');
  if (header && searchToggle && headerSearch) {
    const input = headerSearch.querySelector('input[type="search"]');
    const isMobile = () => window.matchMedia('(max-width: 899px)').matches;
    const close = () => header.classList.remove('is-searching');
    searchToggle.addEventListener('click', (e) => {
      if (!isMobile()) return;
      e.preventDefault();
      const open = !header.classList.contains('is-searching');
      header.classList.toggle('is-searching', open);
      searchToggle.setAttribute('aria-expanded', String(open));
      if (input) {
        /* The inline field is narrow, so it shows the short label while open. */
        if (open) {
          if (!input.dataset.cmLong) input.dataset.cmLong = input.placeholder;
          if (input.dataset.cmShort) input.placeholder = input.dataset.cmShort;
          input.focus();
        } else if (input.dataset.cmLong) {
          input.placeholder = input.dataset.cmLong;
        }
      }
    });
    headerSearch.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        close();
        searchToggle.focus();
      }
    });
    document.addEventListener('click', (e) => {
      if (header.classList.contains('is-searching') && !header.contains(e.target)) close();
    });
  }

  const catbar = document.querySelector('[data-cm-catbar]');
  if (catbar) {
    let last = window.scrollY;
    let ticking = false;
    const update = () => {
      const y = window.scrollY;
      const delta = y - last;
      if (y < 80) catbar.classList.remove('is-hidden');
      else if (delta > 6) catbar.classList.add('is-hidden');
      else if (delta < -6) catbar.classList.remove('is-hidden');
      last = y;
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    catbar.addEventListener('focusin', () => catbar.classList.remove('is-hidden'));
    /* The desktop dropdown is fixed (the bar scrolls sideways and would clip an
       absolutely positioned panel), so it needs the bar's current bottom. */
    const setPanelTop = () => {
      document.documentElement.style.setProperty('--cm-catbar-bottom', Math.round(catbar.getBoundingClientRect().bottom) + 'px');
    };
    setPanelTop();
    window.addEventListener('scroll', setPanelTop, { passive: true });
    window.addEventListener('resize', setPanelTop);
    catbar.addEventListener('pointerover', setPanelTop);
  }

  /* ---------- Molin AI chat: opened from the header button ----------
     The widget lives in molin-shop-ai's (open) shadow root, out of reach of
     the theme stylesheet, so a small style sheet is injected into it that
     hides the floating bubble; the header's chat button calls openChat(). */
  const shrinkMolin = () => {
    const host = document.querySelector('molin-shop-ai');
    if (!host) return false;
    const root = host.shadowRoot;
    if (!root) return false;
    if (root.querySelector('#cm-molin-style')) return true;
    const style = document.createElement('style');
    style.id = 'cm-molin-style';
    // The header chat button replaces the floating bubble on every width;
    // bubblePosition 'right' makes Molin open its chat panel on the right edge.
    style.textContent = 'mw-bubble{display:none!important}';
    host.bubblePosition = 'right';
    root.appendChild(style);
    host.setAttribute('data-cm-ready', '');
    // Header chat button: opens the chat.
    document.querySelectorAll('[data-cm-chat]').forEach((btn) => {
      if (typeof host.openChat !== 'function') return;
      btn.hidden = false;
      if (btn.dataset.cmChatBound) return;
      btn.dataset.cmChatBound = '1';
      btn.addEventListener('click', () => host.openChat());
    });
    return true;
  };
  if (!shrinkMolin()) {
    // Catch the widget as soon as the app embed inserts it (and its shadow root).
    const mo = new MutationObserver(() => {
      if (shrinkMolin()) mo.disconnect();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    let tries = 0;
    const timer = setInterval(() => {
      if (shrinkMolin() || ++tries > 40) {
        clearInterval(timer);
        mo.disconnect();
      }
    }, 250);
  }


  /* ---------- Tabs (cm-tabs section) ---------- */
  document.querySelectorAll('[data-cm-tabs]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[data-cm-tab]')];
    const panels = [...root.querySelectorAll('[data-cm-panel]')];
    const select = (id, focus) => {
      tabs.forEach((t) => {
        const on = t.dataset.cmTab === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach((p) => {
        p.hidden = p.dataset.cmPanel !== id;
      });
    };
    tabs.forEach((t) => {
      t.addEventListener('click', () => select(t.dataset.cmTab));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const i = tabs.indexOf(t);
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        select(next.dataset.cmTab, true);
      });
    });
    /* Buttons inside a panel that jump to another tab (contact page: "Write to us") */
    root.querySelectorAll('[data-cm-goto]').forEach((b) => {
      b.addEventListener('click', () => select(b.dataset.cmGoto, true));
    });
    /* A panel that must start open (contact form's success / error note after a submit) */
    const open = root.querySelector('[data-cm-open-tab]');
    if (open) select(open.dataset.cmOpenTab);
  });
  /* ---------- Product page: thumbnail chevrons + badges in the head card corner ---------- */
  document.querySelectorAll('.cm-product__gallery').forEach((gal) => {
    const mg = gal.querySelector('media-gallery');
    gal.querySelectorAll('[data-cm-gal]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const items = [...gal.querySelectorAll('.thumbnail-list__item')].filter((li) => li.offsetParent !== null);
        if (!items.length || !mg) return;
        const i = items.findIndex((li) => li.querySelector('.thumbnail[aria-current="true"]'));
        const dir = btn.dataset.cmGal === 'next' ? 1 : -1;
        const next = items[(i + dir + items.length) % items.length];
        if (next && typeof mg.setActiveMedia === 'function') mg.setActiveMedia(next.dataset.target, false);
        const list = next && next.parentElement;
        if (list && list.scrollHeight > list.clientHeight) {
          list.scrollTo({ top: next.offsetTop - (list.clientHeight - next.offsetHeight) / 2, behavior: 'smooth' });
        }
      });
    });
  });
  document.querySelectorAll('[data-cm-head]').forEach((card) => {
    const price = card.querySelector('[id^="price-"]');
    if (!price) return;
    const moveBadges = () => {
      // Dawn renders both badges and lets the price block's state classes pick
      // which one shows; copy only the applicable ones into the card corner.
      const box = price.querySelector('.price');
      const onSale = !!box && box.classList.contains('price--on-sale');
      const soldOut = !!box && box.classList.contains('price--sold-out');
      const badges = [...price.querySelectorAll('.badge')]
        .filter((b) => (b.classList.contains('price__badge-sale') && onSale) || (b.classList.contains('price__badge-sold-out') && soldOut))
        .map((b) => b.cloneNode(true));
      let wrap = card.querySelector('.cm-pcard__badges');
      if (!badges.length) {
        if (wrap) wrap.remove();
        card.classList.remove('has-badges');
        return;
      }
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'cm-pcard__badges';
        card.appendChild(wrap);
      }
      wrap.replaceChildren(...badges);
      card.classList.add('has-badges');
    };
    moveBadges();
    new MutationObserver(moveBadges).observe(price, { childList: true, subtree: true });
  });
  /* ---------- Collection sort: themed dropdown driving the native select ---------- */
  const caretSvg = '<svg class="cm-icon" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"/></svg>';
  const backSvg = '<svg class="cm-icon" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="M168.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L97,128Z"/></svg>';
  const enhanceSort = () => {
    document.querySelectorAll('select.facet-filters__sort:not([data-cm-sort]), #FacetFiltersFormMobile select[name="sort_by"]:not([data-cm-sort])').forEach((select) => {
      select.dataset.cmSort = '1';
      const wrap = select.closest('.select');
      if (!wrap) return;
      const label = (select.closest('.facet-filters__field') || wrap.parentElement).querySelector('label');
      const labelText = label ? label.textContent.trim().replace(/:$/, '') : '';
      if (label && label.closest('.mobile-facets__sort')) label.textContent = labelText;
      const details = document.createElement('div');
      details.className = 'cm-sort';
      const summary = document.createElement('button');
      summary.type = 'button';
      summary.className = 'cm-sort__btn';
      summary.setAttribute('aria-haspopup', 'listbox');
      summary.setAttribute('aria-expanded', 'false');
      const menu = document.createElement('ul');
      menu.className = 'cm-sort__menu';
      /* In the filter panel the options open in place, like the category list. */
      const isPage = !!select.closest('#FacetFiltersFormMobile');
      let page = menu;
      if (isPage) {
        details.classList.add('cm-sort--page');
        page = document.createElement('div');
        page.className = 'cm-sort__page';
        const back = document.createElement('button');
        back.type = 'button';
        back.className = 'cm-sort__back';
        back.innerHTML = backSvg + '<span>' + (labelText || '') + '</span>';
        back.addEventListener('click', (e) => {
          e.stopImmediatePropagation();
          details.open = false;
          summary.focus();
        });
        page.append(back, menu);
      }
      page.hidden = true;
      const setOpen = (on) => {
        page.hidden = !on;
        details.classList.toggle('is-open', on);
        summary.setAttribute('aria-expanded', String(on));
      };
      Object.defineProperty(details, 'open', { get: () => !page.hidden, set: (v) => setOpen(!!v) });
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        setOpen(page.hidden);
      });
      const paint = () => {
        const cur = select.options[select.selectedIndex];
        summary.innerHTML = (!isPage && labelText ? '<span>' + labelText + ':</span> ' : '') + (cur ? cur.textContent.trim() : '');
        menu.querySelectorAll('.cm-sort__item').forEach((b) => b.classList.toggle('is-active', b.dataset.value === select.value));
      };
      [...select.options].forEach((opt) => {
        const li = document.createElement('li');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cm-sort__item';
        btn.dataset.value = opt.value;
        btn.innerHTML = '<span>' + opt.textContent.trim() + '</span>' + (opt.value === select.value ? caretSvg : '');
        btn.addEventListener('click', (e) => {
          e.stopImmediatePropagation();
          details.open = false;
          if (select.value === opt.value) return;
          select.value = opt.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
          paint();
        });
        li.appendChild(btn);
        menu.appendChild(li);
      });
      details.append(summary, page);
      wrap.classList.add('cm-sort-hidden');
      wrap.insertAdjacentElement('afterend', details);
      select.addEventListener('change', paint);
      if (!isPage) {
        document.addEventListener('click', (e) => {
          if (details.open && !details.contains(e.target)) details.open = false;
        });
      }
      details.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && details.open) {
          details.open = false;
          summary.focus();
        }
      });
      paint();
    });
  };
  const enhancePrice = () => {
    document.querySelectorAll('.facets__price .field').forEach((field) => {
      const input = field.querySelector('.field__input');
      const label = field.querySelector('.field__label');
      if (input && label) input.placeholder = label.textContent.trim();
    });
  };
  /* Active filter chips: one scrolling row at the bottom of the filter panel,
     above Remove all / Apply, and a count badge on the floating button. Dawn
     re-renders .active-facets on every change, so the row is rebuilt from it
     (cloned facet-remove elements keep their AJAX behaviour). */
  let activeSig = null;
  const renderActive = () => {
    const container = document.querySelector('.cm-collection .facets-container');
    const src = container && (container.querySelector('.active-facets-mobile') || container.querySelector('.active-facets'));
    const footer = container && container.querySelector('.mobile-facets__main > .mobile-facets__footer');
    const fab = container && container.querySelector('.mobile-facets__open-wrapper');
    if (!src || !footer) return;
    const chips = [...src.querySelectorAll('facet-remove')].filter((fr) => !fr.querySelector('.active-facets__button-remove'));
    const sig = chips.map((c) => c.querySelector('a')?.getAttribute('href')).join('|');
    const main = footer.parentElement;
    let row = main.querySelector(':scope > .cm-active');
    let badge = fab && fab.querySelector(':scope > .cm-fab__badge');
    if (sig === activeSig && row && (!fab || (badge && fab.querySelector(':scope > .cm-fab__icon')))) return;
    activeSig = sig;
    if (!row) {
      row = document.createElement('div');
      row.className = 'cm-active';
    }
    if (row.nextElementSibling !== footer) footer.before(row);
    row.replaceChildren(...chips.map((c) => c.cloneNode(true)));
    row.hidden = chips.length === 0;
    if (fab && !fab.querySelector(':scope > .cm-fab__icon')) {
      fab.insertAdjacentHTML('beforeend', '<svg class="cm-fab__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><g class="cm-fab__l1"><line x1="4" y1="8" x2="20" y2="8"/><circle cx="9" cy="8" r="2.4"/></g><g class="cm-fab__l2"><line x1="4" y1="16" x2="20" y2="16"/><circle cx="15" cy="16" r="2.4"/></g></svg>');
    }
    if (fab) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cm-fab__badge';
        badge.setAttribute('aria-hidden', 'true');
        fab.appendChild(badge);
      }
      badge.textContent = String(chips.length);
      badge.hidden = chips.length === 0;
    }
  };
  /* Filter panel: facets with a price range or fewer than four options stay
     open and show their choices inline; their summaries do nothing. */
  const panel = document.querySelector('.cm-collection menu-drawer.mobile-facets__wrapper');
  const panelDetails = panel && panel.querySelector('details.mobile-facets__disclosure');
  const syncInline = () => {
    if (!panelDetails) return;
    const isOpen = panelDetails.hasAttribute('open');
    panelDetails.querySelectorAll('.mobile-facets__main > details.mobile-facets__details').forEach((d) => {
      const n = d.querySelectorAll('.mobile-facets__item').length;
      const inline = !!d.querySelector('price-range') || (n > 0 && n < 4);
      d.classList.toggle('cm-inline', inline);
      if (!inline) {
        const row = d.querySelector(':scope > summary > div');
        if (!row) return;
        let value = row.querySelector('.cm-facet-value');
        if (!value) {
          value = document.createElement('span');
          value.className = 'cm-facet-value';
          value.innerHTML = '<span class="cm-facet-value__text"></span><span class="cm-facet-value__count" hidden></span>';
          row.appendChild(value);
        }
        const valueText = value.querySelector('.cm-facet-value__text');
        const valueCount = value.querySelector('.cm-facet-value__count');
        const picked = [...d.querySelectorAll('.mobile-facets__checkbox:checked')].map((i) => i.closest('label')?.querySelector('.facet-checkbox__text-label')?.textContent.trim()).filter(Boolean);
        const isCategory = /category/.test(d.id);
        const text = picked.length ? picked.join(', ') : (isCategory ? i18n.filter_all_categories || 'All categories' : i18n.filter_all || 'All');
        if (valueText.textContent !== text) valueText.textContent = text;
        if (valueCount.textContent !== String(picked.length)) valueCount.textContent = String(picked.length);
        if (valueCount.hidden !== (picked.length === 0)) valueCount.hidden = picked.length === 0;
        return;
      }
      const summary = d.querySelector(':scope > summary');
      if (summary) {
        summary.tabIndex = -1;
        summary.setAttribute('aria-disabled', 'true');
      }
      if (isOpen && !d.hasAttribute('open')) d.setAttribute('open', '');
    });
  };
  if (panelDetails) {
    panel.addEventListener('click', (e) => {
      const summary = e.target.closest('summary');
      if (summary && summary.parentElement.classList.contains('cm-inline')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
    const scrim = panelDetails.querySelector('form.mobile-facets');
    if (scrim) {
      scrim.addEventListener('click', (e) => {
        if (e.target === scrim && panelDetails.hasAttribute('open')) panelDetails.querySelector(':scope > summary').click();
      });
    }
    new MutationObserver(syncInline).observe(panelDetails, { attributes: true, attributeFilter: ['open'], subtree: true });
  }
  const enhanceFacets = () => {
    enhanceSort();
    enhancePrice();
    renderActive();
    syncInline();
  };
  enhanceFacets();
  const facetsRoot = document.getElementById('main-collection-filters');
  if (facetsRoot) new MutationObserver(enhanceFacets).observe(facetsRoot, { childList: true, subtree: true });
})();

/* ---------- Terms checkbox (R Terms app): one line + read more ---------- */
(() => {
  let i18n = {};
  try {
    i18n = JSON.parse(document.getElementById('cm-i18n').textContent) || {};
  } catch {}
  const more = i18n.terms_more || 'Read more';
  const less = i18n.terms_less || 'Show less';
  let uid = 0;

  const enhance = () => {
    document.querySelectorAll('.terms-relentless:not([data-cm-terms])').forEach((box) => {
      const label = box.querySelector(':scope > label');
      const text = label && label.querySelector(':scope > p');
      if (!text) return;
      label.querySelectorAll(':scope > p').forEach((p) => {
        if (p !== text && !p.textContent.trim()) p.hidden = true;
      });
      text.id = text.id || `cm-terms-text-${++uid}`;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cm-terms__more';
      btn.textContent = more;
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', text.id);
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const open = box.classList.toggle('is-open');
        btn.textContent = open ? less : more;
        btn.setAttribute('aria-expanded', String(open));
      });
      box.setAttribute('data-cm-terms', '');
      box.appendChild(btn);
    });
  };

  enhance();
  document.querySelectorAll('cart-drawer, #main-cart-footer').forEach((root) => {
    new MutationObserver(enhance).observe(root, { childList: true, subtree: true });
  });
})();
